import { createAsyncThunk } from "@reduxjs/toolkit";
import getScanTrackSummaryData from "../../../../configs/apis/scan-track-summary-data/index";
import { downloadExportedScanTrackSummary } from "../../utils/export-utils";

export const fetchSummaryData = createAsyncThunk(
  "scanTrackSummary/fetchSummaryData",
  async ({ filters, page, itemPerPage, additionalInfoColumns, displayLang }) => {
    const response = await getScanTrackSummaryData.getSummaryData(
      filters,
      page,
      itemPerPage,
      additionalInfoColumns || [],
      displayLang || "EN"
    );
    if (!response.success) throw new Error(response.message);
    return response;
  }
);

export const fetchAdditionalInfoFields = createAsyncThunk(
  "scanTrackSummary/fetchAdditionalInfoFields",
  async (companyId) => {
    const response = await getScanTrackSummaryData.getAdditionalInfoFields(
      companyId
    );
    if (!response.success) throw new Error(response.message);
    return response.data || [];
  }
);

export const fetchCompanyList = createAsyncThunk(
  "scanTrackSummary/fetchCompanyList",
  async () => {
    const response = await getScanTrackSummaryData.getCompanyList();
    if (!response.success) throw new Error(response.message);
    return response.data.map((c) => ({ value: c.id, label: c.name }));
  }
);

export const fetchBranchList = createAsyncThunk(
  "scanTrackSummary/fetchBranchList",
  async (companyId) => {
    const response = await getScanTrackSummaryData.getBranchList(companyId);
    if (!response.success) throw new Error(response.message);
    return response.data.map((b) => ({ value: b.id, label: b.name }));
  }
);

export const fetchProductList = createAsyncThunk(
  "scanTrackSummary/fetchProductList",
  async (companyId) => {
    const response = await getScanTrackSummaryData.getProductList(companyId);
    if (!response.success) throw new Error(response.message);
    return response.data.map((p) => ({
      value: p.productUuid,
      label: p.productName,
    }));
  }
);

export const exportData = createAsyncThunk(
  "scanTrackSummary/exportData",
  async (
    { format, filters, columns, companyName, additionalInfoColumns, displayLang },
    { rejectWithValue }
  ) => {
    try {
      const params = {
        ...filters,
        format,
        columns,
        additional_info_columns: additionalInfoColumns || [],
        display_lang: displayLang || "EN",
      };
      const response = await getScanTrackSummaryData.getExportScanTrackSummary(
        params
      );
      downloadExportedScanTrackSummary(response, format, companyName);
      return true;
    } catch (error) {
      return rejectWithValue(error.error || error.message || "Export failed");
    }
  }
);
